import { defineMessages } from 'utils/intl';

export default defineMessages({
  start: 'W tym roku zaczynaliśmy od jednoosobowej działalności gospodarczej.',
  way: 'Przebyliśmy długą drogę: od lokalnego sklepu z komputerami typu „składak”, aż po gotowe rozwiązania światowych marek.',
  employees:
    'Zaczęliśmy od lokalnego sklepu z komputerami, a obecnie jako spółka akcyjna zatrudniamy szerokie grono specjalistów. Centrala firmy znajduje się w Oleśnie, a nasze oddziały zlokalizowane są we Wrocławiu i Krakowie. Jesteśmy oficjalnym przedstawicielem największych producentów sprzętu IT. Świadczymy usługi integratorskie najnowszych rozwiązań technologicznych.',
});
